// @ts-strict-ignore
import Space from 'antd/lib/space';
import Tooltip from 'antd/lib/tooltip';
import { dayjs } from '@/extendedDayjs';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { colorForBetaBuildStatus } from '../../helpers/displayHelpers';
import { RootState } from '../../reducers/reducers';
import { selectAppTimeFormatSetting, selectEffectiveTimezone } from '../../selectors/selectors';
import { convertTo24HourFormat, DatetimeFormat } from '../../timeHelpers';
import { BetaBuild } from '../../types';
import { AppBuildComponent, CIBuildComponent } from '../BuildComponents';
import LinkageIcon from '../icons/LinkageIcon';
import SmallStatusNode from '../SmallStatusNode';

interface BetaBuildHistoryItemHeaderProps extends BetaBuild {
    checkbox: JSX.Element | null;
    appId: string;
}

const BetaBuildHistoryItemHeader: React.FC<BetaBuildHistoryItemHeaderProps> = (
    props: BetaBuildHistoryItemHeaderProps,
) => {
    const use24HourTimeFormat = useSelector((state: RootState) => selectAppTimeFormatSetting(state, props.appId));
    const effectiveTimezone = useSelector((state: RootState) => selectEffectiveTimezone(state, props.appId));
    const dateFormat = DatetimeFormat.ShortMonthDateTime;

    let externalBuildComponent = null;
    let associatedCIBuildComponent = null;

    const appStoreBuild = props.appStoreBuild.appStoreBuild;
    const associatedCIBuild = props.appStoreBuild.associatedCIBuild;

    const uploadedOn = dayjs(appStoreBuild.uploadedAt)
        .tz(effectiveTimezone)
        .format(use24HourTimeFormat ? convertTo24HourFormat(dateFormat) : dateFormat);
    externalBuildComponent = (
        <Tooltip title={`Uploaded on ${uploadedOn}`}>
            <div>
                <AppBuildComponent
                    integrationId={appStoreBuild.integrationId}
                    buildIdentifier={appStoreBuild.buildNumber}
                    isProcessed={appStoreBuild.isProcessed}
                    strong
                />
            </div>
        </Tooltip>
    );

    if (associatedCIBuild) {
        associatedCIBuildComponent = (
            <CIBuildComponent
                integrationId={associatedCIBuild.integrationId}
                buildIdentifier={associatedCIBuild.buildIdentifier}
                strong
            />
        );
    }

    const statusColor = colorForBetaBuildStatus(props.betaStatus);

    return (
        <Space align="center" size="small">
            {props.checkbox}
            <SmallStatusNode color={statusColor} size={10} />
            {externalBuildComponent}
            {externalBuildComponent && associatedCIBuildComponent && <LinkageIcon width={16} height={16} />}
            {associatedCIBuildComponent}
        </Space>
    );
};

export default BetaBuildHistoryItemHeader;
